/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ReviewerScorecardTimeseriesEntity
 */
export interface ReviewerScorecardTimeseriesEntity {
    /**
     * 
     * @type {string}
     * @memberof ReviewerScorecardTimeseriesEntity
     */
    dateBucket?: string;
    /**
     * 
     * @type {number}
     * @memberof ReviewerScorecardTimeseriesEntity
     */
    totalContactDurationSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof ReviewerScorecardTimeseriesEntity
     */
    averageDurationSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof ReviewerScorecardTimeseriesEntity
     */
    averageContactsDurationSeconds?: number;
}

/**
 * Check if a given object implements the ReviewerScorecardTimeseriesEntity interface.
 */
export function instanceOfReviewerScorecardTimeseriesEntity(value: object): boolean {
    return true;
}

export function ReviewerScorecardTimeseriesEntityFromJSON(json: any): ReviewerScorecardTimeseriesEntity {
    return ReviewerScorecardTimeseriesEntityFromJSONTyped(json, false);
}

export function ReviewerScorecardTimeseriesEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewerScorecardTimeseriesEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'dateBucket': json['dateBucket'] == null ? undefined : json['dateBucket'],
        'totalContactDurationSeconds': json['totalContactDurationSeconds'] == null ? undefined : json['totalContactDurationSeconds'],
        'averageDurationSeconds': json['averageDurationSeconds'] == null ? undefined : json['averageDurationSeconds'],
        'averageContactsDurationSeconds': json['averageContactsDurationSeconds'] == null ? undefined : json['averageContactsDurationSeconds'],
    };
}

export function ReviewerScorecardTimeseriesEntityToJSON(value?: ReviewerScorecardTimeseriesEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dateBucket': value['dateBucket'],
        'totalContactDurationSeconds': value['totalContactDurationSeconds'],
        'averageDurationSeconds': value['averageDurationSeconds'],
        'averageContactsDurationSeconds': value['averageContactsDurationSeconds'],
    };
}

